/* eslint-disable no-unused-vars */
// import { userToken, user } from "./cache";

//apollo
// const client = new ApolloClient({
//   uri: "https://71z1g.sse.codesandbox.io/",
//   cache: new InMemoryCache({
//     typePolicies: {
//       Query: {
//         fields: {
//           userToken: {
//             read() {
//               return userToken();
//             },
//           },
//           user: {
//             read() {
//               return user();
//             },
//           },
//         },
//       },
//     },
//   }),
// });

import { ApolloClient, InMemoryCache, from, createHttpLink } from "@apollo/client";
import AWSAppSyncClient, { AUTH_TYPE } from "aws-appsync";

// import {
//   userId
// } from "./cache";
import { Auth } from "aws-amplify";
// AWSAppSync;
import { createAuthLink } from "aws-appsync-auth-link";
import { createSubscriptionHandshakeLink } from "aws-appsync-subscription-link";
import { RetryLink } from "@apollo/client/link/retry";
import { ApolloLink } from "@apollo/client";
import i18next from "i18next";
import { checkLanguage } from "utility";
import { AWS as AppConfig } from "config";

const option = {
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "cache-and-network",
      // fetchPolicy: 'network-only',
    },
  },
  cache: new InMemoryCache({
    // addTypename: false,
    typePolicies: {
      Query: {
        fields: {
          // getHistory: {
          //   merge(existing, incoming){
          //     console.log(incoming)
          //     return incoming
          //   }
          // }
          // userId: {
          //   read() {
          //     return userId();
          //   },
          // },
        },
      },
    },
  }),
};

const checkSessionLink = new ApolloLink((operation, forward) => {
  Auth.currentSession().catch(() => {
    Auth.signOut();
  });
  return forward(operation);
});

const LangLink = new ApolloLink((operation, forward) => {
  operation.setContext({
    headers: {
      language: checkLanguage(i18next.language),
    },
  });
  return forward(operation);
});

export const clientUserPool = new ApolloClient({
  link: from([
    new RetryLink(),
    checkSessionLink,
    LangLink,
    createAuthLink({
      url: AppConfig.aws_appsync_graphqlEndpoint,
      region: AppConfig.aws_appsync_region,
      auth: {
        type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
        jwtToken: async () => (await Auth.currentSession()).getAccessToken().getJwtToken(), // COGNITO USER POOLS
      },
      disableOffline: true,
    }),
    createSubscriptionHandshakeLink(
      AppConfig.aws_appsync_graphqlEndpoint,
      createHttpLink({
        uri: AppConfig.aws_appsync_graphqlEndpoint,
      })
    ),
  ]),
  ...option,
});

export const clientIAM = new ApolloClient({
  link: from([
    new RetryLink(),
    LangLink,
    createAuthLink({
      url: AppConfig.aws_appsync_graphqlEndpoint,
      region: AppConfig.aws_appsync_region,
      auth: {
        type: AUTH_TYPE.AWS_IAM,
        credentials: async () => await Auth.currentCredentials(),
      },
      disableOffline: true,
    }),
    createSubscriptionHandshakeLink(
      AppConfig.aws_appsync_graphqlEndpoint,
      createHttpLink({
        uri: AppConfig.aws_appsync_graphqlEndpoint,
      })
    ),
  ]),
  ...option,
});

// export const client = new AWSAppSyncClient({
//   url: AppSyncConfig.aws_appsync_graphqlEndpoint,
//   region: AppSyncConfig.aws_appsync_region,
//   auth: {
//     type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS, // "AMAZON_COGNITO_USER_POOLS"
//     credentials: async() => await Auth.currentCredentials(),
//     jwtToken: async () => (await Auth.currentSession()).getAccessToken().getJwtToken(), // COGNITO USER POOLS
//   },
//   disableOffline: true,
// }, option);

// export const clientIAM = new AWSAppSyncClient({
//   url: AppSyncConfig.aws_appsync_graphqlEndpoint,
//   region: AppSyncConfig.aws_appsync_region,
//   auth: {
//     type: AUTH_TYPE.AWS_IAM,
//     credentials: async() => await Auth.currentCredentials(),
//   },
//   disableOffline: true,
// }, option);

// export const clientUserPool = new AWSAppSyncClient({
//   url: AppSyncConfig.aws_appsync_graphqlEndpoint,
//   region: AppSyncConfig.aws_appsync_region,
//   auth: {
//     type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
//     jwtToken: async () => (await Auth.currentSession()).getAccessToken().getJwtToken(), // COGNITO USER POOLS
//   },
//   disableOffline: true,
// }, option);

// export default client
